/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { useEffect } from 'react';
import { observer } from 'mobx-react';
import { SubmitDialog } from '@roc/ui';
import { useRequestExtensionForm, useExtensionsStore } from '@roc/feature-loan-details';
import { RequestExtensionForm } from './requestExtensionForm';

interface RequestExtensionDialogProps {
  open: boolean;
  onClose: () => void;
  loanId: string;
}

export const RequestExtensionDialog = observer(({ open, onClose, loanId }: RequestExtensionDialogProps) => {
  const { extensionsStore } = useExtensionsStore();
  const { requestExtensionStore } = useRequestExtensionForm();

  useEffect(() => {
    if (open && loanId) {
      requestExtensionStore.initRequestExtension(loanId);
    }
  }, [open, loanId]);

  const onRequestExtension = async () => {
    if (!requestExtensionStore.isValid || requestExtensionStore.isSubmitting) {
      return;
    }

    const success = await requestExtensionStore.submitLoanExtension();

    if (success) {
      await extensionsStore.initExtensionInternal(loanId);
    }

    onClose();
  };

  const handleClose = () => {
    requestExtensionStore.reset();
    onClose();
  };

  return (
    <SubmitDialog
      open={open}
      maxWidth={'md'}
      handleClose={handleClose}
      cancelButtonText='Cancel'
      title="Request Extension"
      body={<RequestExtensionForm />}
      handleOk={() => onRequestExtension()}
      subTitle="By requesting an extension, you'll be asking for the maturity date to be extended on this loan."
    />
  );
});
